<template>
    <div class="other-products text-center" :class="{ 'other-products--small-button': smallButton }">
        <p class="other-products__text">
            {{ $t('ProductDetails.hotelOffers.text') }}
        </p>
        <a
            class="btn text-uppercase"
            href="#otherHotelProducts"
            :class="{ 'btn-sm': smallButton, 'btn-dark': darkButton, 'btn-primary': !darkButton }"
        >
            {{ $t('Generic.discoverHere') }}
        </a>
    </div>
</template>

<script>
export default {
    name: 'OtherHotelProducts',
    props: {
        smallButton: Boolean,
        darkButton: Boolean
    }
};
</script>

<style scoped lang="scss">
.other-products {
    border: 1px solid var(--border-color);
    background-color: var(--white);

    &__text {
        font-weight: 500;
        margin-bottom: 10px;
    }

    &--small-button {
        opacity: 0.5;
    }
}
</style>
